"use strict";
/**
 * This component connect all global sidemenus and modals
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.GlobalComponents = exports.mapStateToProps = void 0;
var React = require("react");
var recompose_1 = require("recompose");
var react_redux_1 = require("react-redux");
var Types = require("types");
var __1 = require("../");
var UserSettingsModal_1 = require("components/modals/UserSettingsModal");
var UserProjectsModal_1 = require("components/modals/UserProjectsModal");
var mapStateToProps = function (state) {
    return {
        user: state.auth.current.user
    };
};
exports.mapStateToProps = mapStateToProps;
var statePropsExtractable = Types.extractReturnType(exports.mapStateToProps);
var enhance = (0, recompose_1.compose)((0, recompose_1.setDisplayName)('GlobalComponents'), (0, react_redux_1.connect)(exports.mapStateToProps), recompose_1.pure);
exports.GlobalComponents = enhance(function (props) {
    if (props.user.isNone())
        return React.createElement("div", null);
    return (React.createElement(React.Fragment, null,
        React.createElement(__1.FilesTabFileUploadModal, null),
        React.createElement(UserSettingsModal_1.default, null),
        React.createElement(UserProjectsModal_1.default, null),
        React.createElement(__1.Toaster, null)));
});
